<template>
  <section>
    <div class="mx-2 mt-3 mb-2 rounded-lg">
      <figure class="relative flex flex-col justify-center">
        <img
          class="mb-3 object-cover w-full h-28 sm:h-64 rounded-lg"
          :src="Location.img"
          :alt="Location.imgAlt"
        />
        <figcaption
          class="absolute bottom-0 px-3 pb-1 mx-3 self-center text-center whitespace-normal text-2xl sm:text-4xl border border-white text-white bg-dark-500/50  backdrop-blur-xs rounded-lg"
        >
          <span class="capitalize">{{ I18nNO.about }}</span>
          {{ Location.locationName }}
        </figcaption>
      </figure>
    </div>
    <div class="mx-2 mt-3 px-3 pt-3 pb-12 bg-white rounded-lg">
      <Article :article="Location.about" />
    </div>
  </section>
</template>

<script setup lang="ts">
import Location from "@/data/Location";
import PlainI18nNO from "@/data/I18nNO";
const I18nNO = reactive(PlainI18nNO);

useHead({
  title: I18nNO.aboutLink,
});

onMounted(() => window.scrollTo(0, 0));
</script>
